import type { AdLanding } from './adLanding';

/** Trial v3 (2026-09-20): the child's first name from the sheet after the one tap.
 *  Pure helpers — see docs/TRIAL-SERIES-AND-NAME-2026-09.md. */

export const NAME_MAX = 30;
// Letters of any script incl. diacritics, plus space, hyphen and apostrophe — no digits, no symbols.
const NAME_RE = /^[\p{L}][\p{L}' -]{0,29}$/u;

/** Trimmed, single-spaced first name with a capital first letter, or null when it is no plausible name. */
export function cleanName(raw: string | null | undefined): string | null {
  const v = (raw ?? '').replace(/\s+/g, ' ').trim();
  if (v.length < 2 || v.length > NAME_MAX || !NAME_RE.test(v)) return null;
  return v.charAt(0).toUpperCase() + v.slice(1);
}

/** German genitive of a first name: Mia → Mias, Jonas → Jonas’, Max → Max’, Luz → Luz’. */
export function genitive(name: string): string {
  return /[sßxz]$/i.test(name) ? `${name}’` : `${name}s`;
}

/** The landing's premise: with a name its named template, else the nameless text (the episode landings' pooled one). */
export function episodePremise(landing: Pick<AdLanding, 'premise' | 'namedPremise'>, name: string | null | undefined): string {
  const n = cleanName(name);
  if (!n) return landing.premise;
  return landing.namedPremise.replace(/\{Names\}/g, genitive(n)).replace(/\{Name\}/g, n);
}
